<template>
  <div class="+display-flex +justify-content-center +pd-top-md +pd-bottom-md">
    <nav role="navigation" aria-label="Pagination Navigation">
      <ul class="pagination-numbers">
        <li class="pagination-numbers__marker">
          <a
            class="pagination-numbers__marker-item"
            :class="{ '--is-disabled': isFirstPage }"
            :href="prevUrl()"
            rel="prev"
            aria-label="Previous Page"
          >
            <span class="+mg-right-xxs">&laquo;</span>
          </a>
        </li>

        <li
          class="pagination-numbers__marker"
          v-for="page in pages"
          :key="page"
        >
          <a
            class="pagination-numbers__marker-item"
            v-if="page"
            :class="{ '--is-active': currentPage == page }"
            :href="generateUrl(page)"
            :aria-label="`Go to Page ${page}`"
          >
            {{ page }}
          </a>
          <a class="pagination-numbers__marker-item --is-disabled" v-else>
            ...
          </a>
        </li>

        <li class="pagination-numbers__marker">
          <a
            class="pagination-numbers__marker-item"
            :class="{ '--is-disabled': isLastPage }"
            :href="nextUrl()"
            rel="next"
            aria-label="Next Page"
          >
            <span class="+mg-left-xxs">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'cc-pagination',
  props: {
    currentPage: { type: String, required: true },
    totalPages: { type: String, required: true },
    isMobile: { type: Boolean, required: false },
    generateUrl: { type: Function, required: true }
  },
  data() {
    return {
      numberOfLinks: 11
    }
  },
  computed: {
    currentPageNumber() {
      return parseInt(this.currentPage)
    },
    totalPagesNumber() {
      return parseInt(this.totalPages)
    },
    isFirstPage() {
      return this.currentPageNumber === this.pages[0]
    },
    isLastPage() {
      return this.currentPageNumber === this.pages.length
    },
    pages() {
      if (this.numberOfLinks >= this.totalPagesNumber) {
        return new Array(this.totalPagesNumber)
          .fill()
          .map((val, index) => index + 1)
      }

      const pages = []

      pages.push(this.currentPageNumber)

      while (pages.length < this.numberOfLinks) {
        if (pages[0] > 1) {
          pages.unshift(pages[0] - 1)
        }

        if (pages[pages.length - 1] < this.totalPagesNumber) {
          pages.push(pages[pages.length - 1] + 1)
        }
      }

      if (pages[0] != 1) {
        pages[0] = 1
        pages[1] = 2
        pages[2] = null
      }

      if (pages[pages.length - 1] != this.totalPagesNumber) {
        pages[pages.length - 1] = this.totalPagesNumber
        pages[pages.length - 2] = this.totalPagesNumber - 1
        pages[pages.length - 3] = null
      }

      return pages
    }
  },
  methods: {
    nextUrl() {
      if (this.currentPage < this.pages.length) {
        return this.generateUrl(this.currentPageNumber + 1)
      }
    },
    prevUrl() {
      if (this.currentPage > this.pages[0]) {
        return this.generateUrl(this.currentPageNumber - 1)
      }
    }
  }
}
</script>
